import View from './View.vue'
import ViewHeader from './ViewHeader.vue'

export default {
  View,
  ViewHeader
}
